import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { Form } from "react-bootstrap";
import { toast } from "react-toastify";
import { useNavigate, useParams } from "react-router-dom";
import { routes } from "../../../constants/routes";
// import { DocumentService } from "../../../services";
import { TraderUnitService, DocumentTypeService } from "../../../services";
import { Link } from "react-router-dom";
import { handleConsoleError } from "../../../utils/common-methods";

const TraderUnitDocumentModel = {
  id: null,
  unitName: null,
  unitId: null,
  documentName: null,
  documentFile: null,
  documentFileURL: null,
  expiryDate: null,
  documentsType: null,
  isActive: false,
};

const AddTraderUnitDocument = () => {
  // const documentId = TraderUnitService.getDocumentId();
  // const TraderUnitId = DocumentService.getDocumentId();
  const navigate = useNavigate();
  const [documentData, setDocumentData] = useState({
    ...TraderUnitDocumentModel,
  });
  const [file, setFile] = useState(null);
  // const selectedTraderUnit = TraderUnitService.getSelectedTraderUnit();
  const { unitId, documentId } = useParams();
  const [documentTypes, setDocumentTypes] = useState([]);

  const {
    register,
    handleSubmit,
    reset,
    setValue,
    setError,
    clearErrors,
    formState: { errors },
  } = useForm();

  const maxSize = 20 * 1024 * 1024;
  const validTypes = [
    "application/pdf",
    "image/png",
    "image/gif",
    "image/jpeg",
  ];

  const getTraderUnitDocumentByid = async () => {
    try {
      const res =
        (documentId &&
          isGuid(documentId) &&
          (await TraderUnitService.getTraderUnitDocumentById(documentId))) ||
        [];
      const pitchMappedData = { ...TraderUnitDocumentModel, ...res?.data };
      // expiryDate
      if (res?.data && res?.data?.documentFileURL) {
        setFile(res?.data?.documentFileURL);
      }
      pitchMappedData.expiryDate = pitchMappedData?.expiryDate?.split("T")[0];
      setDocumentData(pitchMappedData);

      reset(pitchMappedData);
    } catch (error) {
      const message=handleConsoleError(error);
      toast.error(error?.message|| message);
    }
  };

  const getDocumentTypes = async () => {
    try {
      const response = await DocumentTypeService.getDocumentTypeList();
      if (response?.isSuccess) {
        const dataTypes = response?.data?.filter((doc) => doc.isActive);
        setDocumentTypes(dataTypes || []);
      }
    } catch (error) {
      const message=handleConsoleError(error);
      toast.error(error?.message|| message);
    }
  };

  useEffect(() => {
    getDocumentTypes();
    getTraderUnitDocumentByid();
  }, []);

  // const onSubmit = async (data) => {
  //   try {
  //     let response = null;
  //     const formData = new FormData();
  //     formData.append("id", documentData?.id || "");
  //     formData.append("documentName", data.documentName || "");
  //     formData.append("documentFile", file || null);
  //     if (id) {
  //       // Update existing document
  //       response = await DocumentService.updateTraderUnitDocument(formData);
  //     } else {
  //       // Create new document
  //       response = await DocumentService.addTraderUnitDocument(formData);
  //     }
  //     if (response?.isSuccess) {
  //       toast.success(response?.message);
  //       DocumentService.removeDocumentId();
  //       navigate(routes.TraderUnit_DOCUMENT);
  //     } else {
  //       toast.error(response?.message);
  //     }
  //   } catch (error) {
  //     toast.error(error?.message);
  //   }
  // };
  const isGuid = (str) => {
    const guidRegex = /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/;
    return guidRegex.test(str);
  };
  const onSubmit = async (data) => {
    if (!file) {
      alert("Please upload a file before saving.");
      return;
    }
    try {
      let response = null;
      const formData = new FormData();
      formData.append("unitId", unitId || "");
      formData.append("documentName", documentData?.documentName);
      formData.append("documentFile", file);
      formData.append("expiryDate", documentData?.expiryDate);
      formData.append("documentsType", documentData?.documentsType);
      formData.append("isActive", true);

      if (documentId && isGuid(documentId)) {
        // Update existing document
        formData.append("id", documentId);
      }
      response = await TraderUnitService.updateTraderUnitDocument(formData);
      //   } else {
      //     // Create new document
      //     response = await TraderUnitService.addTraderUnitDocument(formData);
      //   }
      if (response?.isSuccess) {
        toast.success(response?.message);
        // TraderUnitService.removeDocumentId();
        navigate(routes.TRADER_UNIT_DOCUMENT.replace(":unitId", unitId));
      } else {
        toast.error(response?.message);
      }
    } catch (error) {
      const message=handleConsoleError(error)
      toast.error(error?.message || message);
    }
  };

  // const handleIsStatus = (TraderUnit) => {
  //   setDocumentData({
  //     ...documentData,
  //     isActive: TraderUnit?.target?.checked ? true : false,
  //   });
  // };

  // const handleFileChange = (e) => {
  //   const file = e.target.files[0];
  //   let newErrorMessage = "";
  //   if (file) {
  //     if (!validTypes.includes(file.type)) {
  //       newErrorMessage = `File "${
  //         file.name
  //       }" is not a valid document type. Allowed types: ${validTypes
  //         .join(", ")
  //         .replace("application/", "")}`;
  //     } else if (file.size > maxSize) {
  //       newErrorMessage = `File "${
  //         file.name
  //       }" exceeds the maximum size of ${maxSize / (1024 * 1024)}MB.`;
  //     } else {
  //       setError("documentFile", { message: "" });
  //       setFile(e.target.files[0]);
  //       setValue("documentData.documentFile", e.target.files[0]);
  //     }

  //     if (newErrorMessage.length > 3) {
  //       setError("documentFile", { message: newErrorMessage });
  //       e.target.value = "";
  //     }
  //   }
  // };

  const handleFileChange = (e) => {
  const file = e.target.files?.[0];
  if (!file) return;

  const allowedTypes = validTypes
    .map((type) => type.replace("application/", ""))
    .join(", ");

  let errorMessage = "";

  if (!validTypes.includes(file.type)) {
    errorMessage = `File "${file.name}" is not a valid document type. Allowed types: ${allowedTypes}`;
  } else if (file.size > maxSize) {
    const maxSizeMB = (maxSize / (1024 * 1024)).toFixed(2);
    errorMessage = `File "${file.name}" exceeds the maximum size of ${maxSizeMB} MB.`;
  }

  if (errorMessage) {
    setError("documentFile", { message: errorMessage });
    e.target.value = null;
    return;
  }

  // Success case
 // setError("documentFile", { message: "" });
   clearErrors("documentFile"); 
  setFile(file);
  setValue("documentData.documentFile", file);
   //setValue("documentFile", file);
};

  const handleDelet = (e) => {
    try {
      e.preventDefault();
      setDocumentData({ ...documentData, documentFile: null });
    } catch (error) {}
  };

  return (
    <React.Fragment>
      <Form onSubmit={handleSubmit(onSubmit)}>
        <Form.Group controlId="documentName" className="mb-3">
          <Form.Label>
            Document Name <span className="text-danger">*</span>
          </Form.Label>
          <Form.Control
            maxLength={100}
            type="text"
            {...register("documentName", {
              required: "Please enter document name",
            })}
            defaultValue={documentData?.documentName}
            onChange={(e) =>
              setDocumentData({ ...documentData, documentName: e.target.value })
            }
          />
          {errors.documentName && (
            <span className="text-danger">{errors.documentName?.message}</span>
          )}
        </Form.Group>
        <Form.Group controlId="expiryDate" className="mb-3">
          <Form.Label>Expiry Date</Form.Label>
          <Form.Control
            type="date"
            {...register("expiryDate", {
              required: "Please provide expiry date",
            })}
            value={documentData?.expiryDate}
            min={new Date().toISOString().split("T")[0]}
            onChange={(e) =>
              setDocumentData({ ...documentData, expiryDate: e.target.value })
            }
          />
          {errors.expiryDate && (
            <span className="text-danger">{errors.expiryDate?.message}</span>
          )}
        </Form.Group>

        <Form.Group controlId="documentsType" className="mb-3">
          <Form.Label>Document Type</Form.Label>
          <Form.Select
            //  as="select"
            {...register("documentsType", {
              required: "Please select document type",
            })}
            value={documentData?.documentsType}
            onChange={(e) => {
              setDocumentData({
                ...documentData,
                documentsType: e.target.value,
              });
            }}
          >
            <option value="">Select Document Type</option>
            {documentTypes.map((documentType) => (
              <option key={documentType?.id} value={documentType?.id}>
                {documentType?.documentName}
              </option>
            ))}
          </Form.Select>
          {errors.documentsType && (
            <span className="text-danger">{errors.documentsType?.message}</span>
          )}
        </Form.Group>
        {/* {!documentData?.documentFile && ( */}
        <div style={{ display: !documentData?.documentFile ? "block" : "none" }}>
          <Form.Group controlId="documentFile" className="mb-3">
            <Form.Label>
              Document File <span className="text-danger">*</span>
            </Form.Label>
            <Form.Control
              type="file"
              {...register("documentFile", {
                required: !documentData?.documentFile ?"Please provide a document file.":false,
              })}
              accept=".pdf,application/pdf,image/png, image/gif, image/jpeg"
              onChange={handleFileChange}
              // defaultValue={documentData?.documentFile}
            />
            {errors?.documentFile && (
              <span className="text-danger">
                {errors?.documentFile?.message}
              </span>
            )}
          </Form.Group>
        {/* )} */}
        </div>
        {documentData?.documentFile && (
          <div className="delete-food mb-3">
            <Form.Label>Document File</Form.Label>
            <div>
              <label>{documentData?.documentFile}</label>
            </div>
            <a
              href={documentData?.documentFileURL}
              target="_blank"
              rel="noreferrer"
              style={{ marginRight: "10px" }}
            >
              <i className="fa fa-eye"></i>
            </a>
            <Link onClick={handleDelet} style={{ marginRight: "10px" }}>
              <i className="ri-delete-bin-line"></i>
            </Link>
          </div>
        )}

        {/* <Form.Group controlId="isActive" className="mb-3 custom-check">
          <Form.Label>Status</Form.Label>
          <Form.Check
            type="checkbox"          
            checked={documentData?.isActive} // Controlled by state
            onChange={handleIsStatus} // Handle change TraderUnit
          />        
        </Form.Group> */}

        <button
          className="btn btn-primary mt-3"
          type="button"
          onClick={handleSubmit(onSubmit)}
        >
          Save
        </button>
      </Form>
    </React.Fragment>
  );
};

export default AddTraderUnitDocument;
